import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { settings } from '../../../settings';
import { createPasswordType } from '../../models/Interfaces/createPassword';

@Injectable({
  providedIn: 'root',
})
export class CreatepasswordService {
  api = settings.API_URL;
  constructor(private http: HttpClient) {}

  createPasswordRequest(
    createPasswordParams: createPasswordType,
  ): Observable<any> {
    return this.http.put(
      this.api + '/api/login/resetPassword',
      createPasswordParams,
      { responseType: 'text' },
    );
  }
}
